require('./bootstrap');

import liffInit from './services/liff';

liffInit(process.env.MIX_CAST_LOGIN_LIFF_ID, 'cast');
